// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","zGreen":"#BFD730","secondary":"rgb(0, 0, 124)","calendar":"TgPK","calendarGrid":"_3BhO","calendarHeader":"_3eOj","calendarGridItem":"_2me-","dayHeader":"_2xfD","calendarDatepicker":"_3sT_"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Input/DatePicker/Calendar.scss
// module id = AU2B
// module chunks = 0